import { Component, Input, forwardRef, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EditableCellComponent),
    multi: true,
};

@Component({
    selector: 'editable-cell',
    templateUrl: './editable-cell.component.html',
    styleUrls: ['./editable-cell.component.css'],
    providers: [VALUE_ACCESSOR],
})
export class EditableCellComponent implements ControlValueAccessor {
    @ViewChild('writeComponent')
    writeComponent!: ElementRef;

    @ViewChild('readComponent')
    readComponent!: ElementRef;

    @Output()
    valueChange: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    isReadOnly: boolean = true;

    @Input()
    model: any;

    @Input()
    path!: string;

    editing: boolean = false;

    public onChange: Function = Function.prototype;
    public onTouched: Function = Function.prototype;

    get writeWidth() {
        return this.readComponent.nativeElement.getBoundingClientRect().width;
    }

    writeValue(value: any) {
        this.model = value;
    }

    registerOnChange(fn: (_: any) => {}): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => {}): void {
        this.onTouched = fn;
    }

    onBlur() {
        this.editing = false;
    }

    onValueChange(e: Event & { target: HTMLInputElement }) {
        this.model[this.path] = e.target.value;
        this.valueChange.emit(this.model);
    }

    onEdit() {
        if (this.isReadOnly) return;

        this.editing = true;
        setTimeout(() => {
            this.writeComponent.nativeElement.focus();
        }, 0);
    }
}
